import { ConfigState } from '@mfe/store/config';

export const checkScenario = ({
  registerToken, customerToken, accessToken, accesstoken4p,
}: ConfigState) => ({

  isRaittNoTokensWithInterception: (
    // if no token at all (=RAITT), auth headers will be added by intercepting backend calls
    !registerToken && !customerToken && !accessToken && !accesstoken4p
  ),

  isAuthOverride: !!(
    customerToken || (registerToken && accessToken)
  ),

});
